module.exports = __webpack_public_path__ + "img/frame.76a8cb7e.webp";